import routes from 'js/core_pre_webpack/routes';

// Get the current user's CSRF token from
// the meta tag in the document's head
export const getCsrfToken = () => {
  const csrfToken =
    Array.from(document.head.querySelectorAll('meta')).find(
      (x) => x.name === 'csrf-token',
    )?.content ?? '';

  return csrfToken;
};

export const upgradeUrl = () =>
  routes.upgrade_url({
    feature: 'default',
    trigger: 'author-badge',
  });
